import React, { memo, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { deleteLV, getAnalysenRequestData, getParsedData, updateProjectStatus } from '../../API/analysenrequestdata';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import '../../index.css';
import '../../Styles/Analysen Request/analyserequest.css';
import { faFileAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { dateFormatSort, getOut, showWebReport } from '../../Utils/Common';
import { Dexie } from 'dexie';
import moment from 'moment';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import { Button, Form, Modal, Row } from 'react-bootstrap';
import $ from 'jquery';
import { getAdvices } from '../../API/advices';
//import {setAllAdvicesDB} from '../../Database/AdvicesDAO';
import { invokeAnalyseEndpoint , invokeLabellingEndpoint} from '../../Utils/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { X } from 'react-feather';
import { Multiselect } from 'multiselect-react-dropdown';
import { getIndustries } from '../../API/industry';
//import {getCurrentAnalyse} from "../../API/annotatorApi";
import { isHandwaiPerson, isSuperAdmin } from "../../Utils";
import { getMatchedPosition } from "../../API/parser";
//import {getMatchedPosition} from "../../API/parser";
//import {getCurrentAnalyse} from "../../API/annotatorApi";


// To get the logged-in user roles from local storage
// function getLoggedInUserRole() {
//     //let userRoles = sessionStorage.getItem('roles');
//     //let isSuperAdmin = isSuperAdmin()
//     //userRoles.includes('Handwai-Super-Admin');
//     //let isAdmin = userRoles.includes('Admin');
//     if (isSuperAdmin()) {
//         return 'superAdmin';
//     } else if (isAdmin()) {
//         return 'Admin';
//     } else {
//         return 'invalidUser';
//     }
// }

function AnalyseRequest({ lvstatus }) {
    async function deletingTestLV(el, uid, s3url) {
        if (uid === 'delete') {
            await deleteLV(LvToBeDeleted);
            setTimeout(function () {
                window.location.reload(0.5);
            }, 500);
            el.preventDefault();
        } else {
            setLvToBeDeleted({ uid: uid, s3url: s3url });
            setdeleteLvModalShow(true);
        }
    }

    async function deleteLVMod(e) {
        if (e.target.value === 'Endgültig löschen') {
            setdisplayDelete(false);
        } else {
            setdisplayDelete(true);
        }
    }

    let history = useHistory();
    const [analyserequestData, setanalyserequestData] = useState([]);
    const [isLoadingLV, setisLoadingLV] = useState(true);

    const [deleteLvModalShow, setdeleteLvModalShow] = useState(false);
    const [displayDelete, setdisplayDelete] = useState(true);
    const initiallvtobedeleted = { uid: "", s3url: "" }
    const [LvToBeDeleted, setLvToBeDeleted] = useState(initiallvtobedeleted);

    const useStyles = makeStyles((theme) => ({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff'
        }
    }));

    const [isLoadingAI, setIsLoadingAI] = useState(false);
    const [isLoadingCategories, setIsLoadingCategories] = useState(false);
    const classes = useStyles();

    //Onclick of resume button, directs to annotator page
    const resumeAnalyse = async (el, status, project, adviceCatalog) => {
        console.log(adviceCatalog)
        let advices = await getAdvices();
        advices = advices.response

        let rsl = await getParsedData(project)

        if (status === "in-progress") {
            setIsLoadingAI(true);
            setIsLoadingCategories(true);
            let lvData = rsl.data;

            let oz = lvData.OZ;

            // Create an array of promises for concurrent execution
            const promises = oz.map(async (item) => {
                if (item.type === 'Item') {
                    try {
                        // Assuming getMatchedPosition returns a promise
                        let matches = await getMatchedPosition(item.ltext_hashvalue);
                        let matchData = matches.data;
                        let count = matchData.length;
                        item.matchCount = count;
                    } catch (error) {
                        console.error('Error fetching matched position:', error);
                    }
                }
            });

            // Wait for all promises to resolve
            await Promise.all(promises);

            // Update the original data with the modified 'oz'
            rsl.data.OZ = oz;
        }

        if (rsl.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`)
        }
        let data = []
        if (status === 'in-progress' || status === 'Completed') {
            if (data.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
                getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`)
            }
        }
        if (status !== "hochgeladen") {
            setIsLoadingAI(false)
            history.push(process.env.REACT_APP_FRONTEND_PATH_ANNOTATORPAGE, {
                lvstatus: status,
                lvList: rsl,
                lvID: project.uploadlv_id,
                links: {
                    efb221CDNLink: project.efb221,
                    vhb211CDNLink: project.vhb211,
                    vhb213CDNLink: project.vhb213,
                    vhb214CDNLink: project.vhb214
                },
                adviceList: advices,
                projectFirm: project._Company__company_name,
                projectuploader: project.user_id

            })
        } else {
            alert("Parsing in progress, your processed LV will be available in 'open' lv section ")
            window.location.reload();
        }
        el.preventDefault();
    };

    /***
     * Function to toinvoke brands identification endpoint
     * @param o
     */
    const handleAIAnalyseClick = async (o) => {
        // Circle Loading Animation - Starts
        setIsLoadingAI(true);
        setIsLoadingCategories(true)

        let parsedData = await getParsedData(o)
        // alert(121212)
        await Promise.all([
            invokeAnalyseEndpoint(parsedData)
            .then(function (response) {
                // Circle Loading Animation - Stops
                console.log(response, "ai");
                alert(response);
                setIsLoadingAI(false);
                return response;
            })
            .catch((error) => {
                // Circle Loading Animation - Stops
                setIsLoadingAI(false);
                alert('server error: ' + error);
            }),
            invokeLabellingEndpoint(parsedData)
            .then(function (response) {
                console.log(response, "labelling")
                alert(response);
                setIsLoadingCategories(false);
                return response;
            })
            .catch((error) => {
                setIsLoadingCategories(false);
                alert('server error: ' + error);
            })]
        )
    };

    /***
     * Function to get statuses of AI pipeline and models
     * @param o
     */
    const getStatusOfPipeline = async (o) => {
        history.push(process.env.REACT_APP_FRONTEND_PATH_LVANALYSESTATUSPAGE, {
            lvObject: [o]
        });
    };

    /**
     * Retrieves LV Industry data from DB
     * @returns {Promise<*|void>}
     */
    // const getSelectedLVIndustryData = async () => {
    //     return getIndustries();
    // };

    useEffect(async () => {
        setisLoadingLV(false);
        // clear localstorage, empty db
        localStorage.clear();
        // Delete the IndexedDB
        Dexie.delete('HandwaiDB');

        // API call
        const analyserequest_data = await getAnalysenRequestData(lvstatus);
        const adviceCatalog = []
        let optionValues = [];


        getIndustries().then((r) => {

            if (r.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
                getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
            }
            r.map((item) => optionValues.push(item.industry_name));
        });


        //let selectedLVIndustryData = await getSelectedLVIndustryData();

        if (analyserequest_data.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        }

        const analyserequestdatas = analyserequest_data.result.map((o) => {
            //moment(o.upload_date, [moment.ISO_8601,'MM-DD-YYYY']).format('DD.MM.YYYY')
            return (
                <tr key={o.uploadlv_id}>
                    <td>{o.project_name}</td>
                    <td>{o.uploadlv_id}</td>
                    <td>{o._Company__company_name}</td>
                    <td>
                        {o._User__first_name} {o._User__last_name}
                    </td>
                    <td>{moment(o.submission_date, [moment.ISO_8601, "YYYY-MM-DD", "DD/MM/YYYY","DD.MM.YYYY"]).format('DD.MM.YYYY')}</td>
                    {/*<td>{moment(o.submission_date).format('DD.MM.YYYY')}</td>*/}
                    {/*<td>{o.upload_date}</td>*/}
                    <td>{moment(o.upload_date, [moment.ISO_8601, "YYYY-MM-DD", "DD/MM/YYYY","DD.MM.YYYY"]).format('DD.MM.YYYY')}</td>
                    <td className="centerStyle">
                        <Button
                            onClick={() => {
                                sessionStorage.setItem("webreport", "true")
                                showWebReport(history, o)
                            }
                            }
                            className="handwai-btn-report addHeightWidth35"
                            disabled={o.status !== process.env.REACT_APP_BASE_LVCOMPLETED}
                        >
                            <FontAwesomeIcon icon={faFileAlt} />
                        </Button>
                        <span>&nbsp; </span>
                    </td>
                    <td className="centerStyle">
                        {/*{o.status == null && (*/}
                        {o.status === 'Unknown' && (
                            <Button
                                id={o.uploadlv_id}
                                onClick={(el) => resumeAnalyse(el, 'hochgeladen', o, adviceCatalog)}
                                className="handwai-btn-logout addWidth90"
                                disabled={o.s3uploadURL == null}
                            >
                                Start
                            </Button>
                        )}
                        {o.status === 'open' && (
                            <Button
                                id={o.uploadlv_id}
                                onClick={(el) => resumeAnalyse(el, o.status, o, adviceCatalog)}
                                className="handwai-btn-login addWidth90"
                                disabled={o.s3uploadURL == null}
                            >
                                Resume
                            </Button>
                        )}
                        {o.status === 'in-progress' && (
                            <Button
                                id={o.uploadlv_id}
                                onClick={(el) => resumeAnalyse(el, o.status, o, adviceCatalog)}
                                className="handwai-btn-password-reset addWidth90"
                                disabled={o.s3uploadURL == null}
                            >
                                Resume
                            </Button>
                        )}
                        {o.status === 'Completed' && (
                            <Button
                                id={o.uploadlv_id}
                                onClick={(el) => resumeAnalyse(el, o.status, o, adviceCatalog)}
                                className="handwai-btn-login addWidth90"
                                disabled={o.s3uploadURL == null}
                            >
                                Reopen
                            </Button>
                        )}
                    </td>
                    <td className="centerStyle">
                        {o.status === 'open' && (
                            <Button onClick={() => handleAIAnalyseClick(o)} className="handwai-btn-resume addWidth90">
                                {' '}
                                Analyse{' '}
                            </Button>
                        )}
                        <br />
                        <br />
                        {(o.status === 'open' || o.status === 'in-progress') && (
                            <Button onClick={() => getStatusOfPipeline(o)} className="handwai-btn-resume addWidth90">
                                {' '}
                                View{' '}
                            </Button>
                        )}
                    </td>
                    <td>{o.duplication_check}</td>

                    {/*Delete lv button*/}
                    <td>
                        <button
                            onClick={(element) => deletingTestLV(element, o.uploadlv_id, o.s3uploadURL)}
                            className="lvDelete"
                            style={{ padding: 5, fontSize: 15 }}
                        >
                            <FontAwesomeIcon icon={faTrash} /> Delete
                        </button>
                    </td>

                    {/*LV Industry*/}
                    <td>
                        <Multiselect
                            className="chip multiSelectContainer optionContainer searchBox"
                            placeholder={'wählen Sie'}
                            isObject={false}
                            options={optionValues}
                            onSelect={(_x, selectedItem) => {
                                if (!(Array.isArray(o.industry))) {
                                    o.industry = []
                                }
                                o.industry.push(selectedItem)
                                updateProjectStatus({
                                    "uploadlv_id": o.uploadlv_id, "industry": o.industry
                                })
                                window.location.reload()
                            }}
                            onRemove={(_x, removeItem) => {
                                o.industry = o.industry.filter(function (e) {
                                    return e !== removeItem;
                                })
                                updateProjectStatus({ "uploadlv_id": o.uploadlv_id, "industry": o.industry })
                                window.location.reload()

                            }}
                            selectedValues={
                                o.industry
                            }
                            avoidHighlightFirstOption={true}
                            showCheckbox
                        />
                    </td>
                </tr>
            );
        });

        setanalyserequestData(analyserequestdatas);

        dateFormatSort();

        // Datatable initialisation
        let ex = $('#' + lvstatus).DataTable({
            "searching": true,
            "paging": true,
            language: {
                fontcolor: 'white',
                url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
            },
            order: [[5, 'desc']],
        });

        //Visibility of deleteLV column
        //let logged = getLoggedInUserRole();
        //if (logged === 'superAdmin') {
        if (isSuperAdmin()) {
            ex.columns([10]).visible(true);
        } else {
            ex.columns([10]).visible(false);
        }
        if (!isHandwaiPerson()) {
            ex.columns([2, 7, 8, 9, 10, 11]).visible(false);
        }


        $('#reset').click(function () {
            ex.search('').draw();
        });

    }, []);

    return (
        <>
            {(isLoadingAI && isLoadingCategories) ? (
                <Backdrop
                    className={classes.backdrop}
                    open={true}
                    style={{
                        zIndex: 20,
                        opacity: 0.8,

                        color: "white"
                    }}
                >
                    <Grid
                        container
                        alignItems="center"
                        justify="center"
                        alignContent="center"
                    >
                        <Grid item xs={12} align="center">
                            <CircularProgress />
                        </Grid>
                        <Grid item xs={12} align="center">
                            <Typography variant="body2" style={{ color: "White" }}>
                                <b>Building and Transforming Data</b>
                            </Typography>
                        </Grid>
                    </Grid>
                </Backdrop>
            ) : (
                ''
            )}
            <div className="handwai-dark analysenrequestborerStyle">
                <table id={lvstatus} className="table">
                    <thead>
                        <tr>
                            <th data-sortable="true" data-searchable="true">
                                Projektname
                            </th>
                            <th data-sortable="true" data-searchable="true">
                                LV-ID
                            </th>
                            <th data-sortable="true" data-searchable="true">
                                Firma
                            </th>
                            <th data-sortable="true" data-searchable="true">
                                Benutzer
                            </th>
                            <th data-sortable="true" data-searchable="true">
                                Submissionsdatum
                            </th>
                            <th data-sortable="true" data-searchable="true">
                                Hochgeladen am
                            </th>
                            <th data-sortable="true" data-searchable="true">
                                Ihre Analyse
                            </th>
                            <th className="centerStyle">Action</th>
                            <th className="centerStyle">AI Analysis</th>
                            <th data-sortable="true" data-searchable="true">
                                Duplication Check
                            </th>
                            <th data-sortable="true" data-searchable="true">
                                Delete
                            </th>
                            <th>Industrie</th>
                        </tr>
                    </thead>
                    <tbody>{analyserequestData}</tbody>
                </table>
                {isLoadingLV ? (
                    <div>
                        <Loader type="ThreeDots" color="#1abc9c" timeout={3000} />
                    </div>
                ) : (
                    ''
                )}
            </div>

            <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                animation={false}
                show={deleteLvModalShow}
                onHide={() => {
                    setdeleteLvModalShow(false);
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Objekte endgültig löschen?</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Label>
                        Um das Löschen zu bestätigen, geben Sie Endgültig löschen in das Texteingabefeld ein.
                    </Form.Label>
                    <Form>
                        <Form.Group as={Row} controlId="deleteInput">
                            <Form.Control
                                type="text"
                                placeholder="Endgültig löschen"
                                onChange={(e) => deleteLVMod(e)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        size="sm"
                        variant="outline-dark"
                        style={{ width: '40%' }}
                        onClick={() => {
                            setdeleteLvModalShow(false);
                        }}
                    >
                        <X />
                        &nbsp;&nbsp;Abbrechen
                    </Button>

                    <Button
                        style={{ width: '40%' }}
                        disabled={displayDelete}
                        size="sm"
                        block
                        variant="outline-success"
                        onClick={(el) => deletingTestLV(el, 'delete', "")}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                        &nbsp;&nbsp;Objekte löschen
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default memo(AnalyseRequest);